import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import { ServicesIndex, ServiceDetail } from "@/pages/Services";
import BeforeAfter from "@/pages/BeforeAfter";
import License from "@/pages/License";
import Certificates from "@/pages/Certificates";
import Academy from "@/pages/Academy";
import Consultations from "@/pages/Consultations";
import Testimonials from "@/pages/Testimonials";
import { BlogIndex, BlogPost } from "@/pages/Blog";
import Contacts from "@/pages/Contacts";
import Booking from "@/pages/Booking";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<ServicesIndex />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/before-after" element={<BeforeAfter />} />
          <Route path="/license" element={<License />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/academy" element={<Academy />} />
          <Route path="/consultations" element={<Consultations />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
